define([
	"csi/def",
	"csi/def/ActionFactory",
	"./_StateAction"
], function(def,ActionFactory,_StateAction) {

	return ActionFactory.declare("Revise", _StateAction, {
		m_tag: "Revise",

		constructor: function(obj) {
			if (!this.m_typeControl) {
				this.m_typeControl = def.ACTION_ICON;
				this.m_class = "iconRevise " + (this.m_class || "");
			}
		}
	});
});